/**
 * 📋 SDLC 6.5.0 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/pages/dashboards/EmployeeDashboard.tsx
 * PURPOSE: Employee Dashboard (SC-019-EMP-HOME) — HUB nhân viên, hội tụ wireframe
 *          ĐÍCH temp/sc-hub-draft.md (1 định nghĩa chung web+mobile).
 *          2026-08-25: triển khai các gap G2–G7 theo DECISION LOG
 *          SC-019-EMP-HOME-WIREFRAME-AUDIT-2026-08-24:
 *          - G2: nút Chấm công vào/ra ĐIỀU HƯỚNG sang /attendance (như mobile
 *            goToTab('Attendance')) — gỡ hoàn toàn flow chấm công tại chỗ
 *            (useClockAction, modal ảnh/timemark) khỏi HUB.
 *          - G3: thêm state EMPTY (toàn bộ main = 1 empty-state card) và FRESH
 *            (card giải thích không nút + quick-tiles chỉ 2 ô, bỏ Phiếu lương).
 *          - G4: LOADING = skeleton header + card + bottom-nav; ERROR = banner
 *            "⚠ Không tải được dữ liệu trang chủ." + chip DASH-{status} +
 *            "Thử lại", thay toàn bộ main.
 *          - G5: greeting "Xin chào" CHỈ state DEFAULT, còn lại "Chào"; bỏ emoji
 *            👋/🟢/🔴 khỏi nhãn thật.
 *          - G6: "Ca được giao tuần này" render mức NGÀY chuẩn mobile
 *            WeekShiftList.tsx (có ca · Nghỉ (ca đã huỷ) · — Không có ca · 📍).
 *          - G7: state DEFAULT-ENDED theo FRAME 1c WIREFRAME-EMPLOYEE-FLOW.md +
 *            SPEC-0207 + FR-SS-001 Scenario A/C (pill "Đã hết ca" + giờ vào/ra +
 *            CTA ca 2 guard 2 ca/ngày).
 *          - Q4: gỡ các section chỉ-web (task list inline, ca sắp tới, ca hôm
 *            nay, SOP inline, status badge 3 trạng thái, Live/offline indicator,
 *            timing warning, ảnh chấm công).
 *          Giữ nguyên: bottom-nav 4 tab (Q1), chuông thông báo thật, tile
 *          Phiếu lương locked "Sắp có", pull-to-refresh.
 *          2026-09-02 (Issue #666 / BOT-003, @coder): thêm icon Đăng xuất
 *          nhỏ cạnh chuông thông báo trong header — trước đó lối logout DUY
 *          NHẤT là qua tab "Tôi" (ProfilePage.tsx:120-127), không có
 *          affordance trực tiếp ở trang chủ (khác ManagerLayout.tsx /
 *          TenantAdminLayout.tsx, cả hai đều có "Đăng xuất" trong shell).
 *          Bổ sung AN TOÀN — gọi lại đúng useAuthStore().logout() như
 *          ProfilePage.tsx, KHÔNG thay thế nút trong tab Tôi.
 *          2026-09-02 (#704 BOT-015): FRESH-state text rẽ nhánh theo
 *          data.hasDraftSchedule — NV có ca DRAFT (Manager đang soạn, chưa
 *          xuất bản) thấy "Lịch đang được soạn, chưa công bố" thay vì
 *          "Chưa được phân ca" (sai lệch — NV thực ra CÓ ca).
 *          2026-09-04 (structural + button-proportion parity vs mobile/src/
 *          screens/HomeScreen.tsx, sibling pass to AttendanceModern.tsx /
 *          ScheduleModern.tsx same-date work — read-only structural audit,
 *          confirmed mismatches, not invented):
 *          - Card "Chấm công" title: mobile's CardHeader(title="Chấm công")
 *            renders in ALL 4 states (DEFAULT/IN-SHIFT/ENDED/FRESH —
 *            HomeScreen.tsx:451-456 for FRESH, :488-496 for the shared
 *            DEFAULT/IN-SHIFT/ENDED return). Web only rendered the title in
 *            DEFAULT/IN-SHIFT — FRESH and ENDED silently dropped it. Added
 *            the title to both; ENDED now pairs it with .endedPill inside
 *            .cardTitleRow (same title+Pill row shape IN-SHIFT already uses),
 *            matching CardHeader's title+action layout.
 *          - ERROR retry button: mobile renders the retry HomeButton as a
 *            separate full-width sibling AFTER the Banner (HomeScreen.tsx:
 *            395-407), not nested inside it. Web had it nested inside
 *            .errorBanner (which is align-items:flex-start), so it rendered
 *            small/left-aligned instead of the full-width secondary CTA
 *            mobile shows. Moved it out to a sibling of the banner inside
 *            <main> — see EmployeeDashboard.module.css same-date entry for
 *            the matching width/min-height/radius fix.
 *          Reviewed, kept as intentional (not changed): the "Tính năng khác"
 *          quick-link strip has no card-wrap/title in web (mobile wraps it in
 *          Card+CardHeader) — .quickActionRow's existing ISS-EMP-6 comment
 *          (2026-08-16) documents this exact element was the one trimmed to
 *          avoid the fixed bottom-nav overlay band; adding a card+title back
 *          would reintroduce that measured collision. See .module.css.
 * SDLC FRAMEWORK VERSION: 6.5.0 (7-Pillar + 9 Mental Models + Long-Running Agent Protocol)
 * DATE: 2026-09-04
 * COMPLIANCE: SDLC 6.5.0 + SC-019-EMP-HOME wireframe ĐÍCH (temp/sc-hub-draft.md)
 * PILLAR: P1 (Stage 04 - BUILD) + P2 (Sprint Governance) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 3: Zero-Mock Tolerance, Rule 4: Tier-3 Code Review
 *
 * CTO MANDATE: 100% design token usage — Zero inline styles — Zero hardcoded colors
 *
 * @business-context
 * - Domain: Employee Self-Service, Dashboard Visualization, Vietnamese F&B
 * - Impact: Employee Experience, Self-Service, Engagement
 * - Stakeholders: Employees (71), HR Team, Brand Team
 *
 * @technical-architecture
 * - Layer: Presentation Layer (view only — all logic in hooks)
 * - Pattern: CSS Modules + Design Tokens + Custom Hooks
 * - Dependencies: React 18, TanStack Query v5, CSS Modules, NQH Design Tokens
 * - Design System: EmployeeDashboard.module.css
 *
 * @cross-references
 * - Wireframe ĐÍCH: temp/sc-hub-draft.md (SC-019-EMP-HOME)
 * - Decision log: docs/09-govern/07-technical-reports/05-design-audit/SC-019-EMP-HOME-WIREFRAME-AUDIT-2026-08-24.md
 * - Flow frames: docs/02-design/04-ui-ux-design/WIREFRAME-EMPLOYEE-FLOW.md (FRAME 1c)
 * - Requirements: BR-DASH-002, BR-ATTN-001, FR-SS-001, SPEC-0207
 * - Issue #666 / BOT-003: thêm nút Đăng xuất trực tiếp ở trang chủ nhân viên
 *   (NOTE: chưa có quyết định chính thức @architect/@designer xác nhận
 *   "chỉ logout qua tab Tôi" là chủ đích mobile-first hay thiếu sót — PR mô
 *   tả cả 2 khả năng, không tự quyết thay)
 * - Mobile reference: mobile/src/screens/HomeScreen.tsx, components/ui/WeekShiftList.tsx
 * - Hooks: src/hooks/useEmployeeDashboard.ts, useWebSocket.ts, useSchedule.ts
 * - Tests: frontend/tests/pages/EmployeeDashboard.test.tsx
 *
 * @design-compliance
 * - Inline Styles: 0 ✅
 * - Hardcoded Colors: 0 ✅
 * - Design Token Usage: 100% ✅
 * - Accessibility: ARIA compliant, keyboard navigation, focus-visible ✅
 */

import React, { useState, useCallback, useRef, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, LogOut } from 'lucide-react';
import { useAuthStore } from '../../store/auth';
import { useEmployeeDashboard } from '../../hooks/useEmployeeDashboard';
import { useSchedule } from '../../hooks/useSchedule';
import { useWebSocket } from '../../hooks/useWebSocket';
import type { Schedule } from '../../services/api/schedule';
import { useNotifications } from '../../hooks/useNotifications';
import { NotificationDropdown } from '../../components/navigation/NotificationDropdown';
import { EmployeeBottomNav } from '../../components/navigation/EmployeeBottomNav';
import styles from './EmployeeDashboard.module.css';

// ============================================================================
// Vietnamese labels — SSOT: NHÃN VI trong wireframe SC-019-EMP-HOME
// ============================================================================

const VI = {
  greetingDefault: (name: string) => `Xin chào, ${name}`,
  greetingShort: (name: string) => `Chào, ${name}`,
  notScheduled: 'Chưa được phân ca',
  // Issue #666 / BOT-003: shortcut logout ở header — nhãn khớp
  // ProfilePage.tsx:127 (nút logout gốc trong tab "Tôi").
  logout: 'Đăng xuất',
  // #704 (BOT-015): NV CÓ ca (Manager đang soạn), chỉ chưa xuất bản — KHÁC
  // "chưa được phân ca" (chưa từng có ca nào). Xem hasDraftSchedule.
  notPublishedYet: 'Lịch đang được soạn, chưa công bố',
  attendance: {
    title: 'Chấm công',
    clockIn: 'Chấm công vào',
    clockOut: 'Chấm công ra',
    // Verbatim khớp mobile home.i18n.ts:120 attendance.clockInNote.
    clockInNote: 'GPS trong bán kính chi nhánh + ảnh selfie. Mở tab Chấm công để bắt đầu.',
    todayHasShift: (start: string, end: string) => `Hôm nay: bạn có ca làm lúc ${start}–${end}`,
    inShiftLine: (t: string) => `Đã vào ca lúc ${t}`,
    workingPill: 'Đang làm',
    checklistLink: 'Xem checklist ca (tuỳ chọn)',
    endedPill: 'Đã hết ca',
    endedMeta: (inT: string | null, outT: string | null) =>
      `Vào ${inT ?? '--:--'} · Ra ${outT ?? '--:--'}`,
    secondShiftCta: 'Chấm công vào (ca 2)',
    limitReason: 'Đã đạt giới hạn 2 ca/ngày (SPEC-0207)',
    freshNote: 'Chưa có ca làm việc. Quản lý sẽ phân ca cho bạn; bạn sẽ nhận được thông báo.',
    // #704 (BOT-015): biến thể freshNote khi hasDraftSchedule=true — NV CÓ
    // ca, Manager chỉ chưa bấm Xuất bản. KHÔNG lộ chi tiết ca DRAFT (ngày/
    // giờ/chi nhánh) — chỉ báo trạng thái chung, đúng nguyên tắc ẩn DRAFT.
    freshNoteDraft: 'Quản lý đang soạn lịch làm việc cho bạn, chưa công bố. Bạn sẽ nhận được thông báo khi lịch được xuất bản.',
  },
  stats: {
    title: 'Tuần này',
    shifts: 'Ca làm',
    tasks: 'Nhiệm vụ chờ',
    late: 'Đi muộn',
    onTime: 'Đúng giờ',
    infoA11y: 'Giải thích số liệu',
  },
  statSheet: {
    title: 'Số liệu tuần này là gì?',
    shifts: 'Ca làm: số ca còn hiệu lực từ Thứ 2 đến Chủ nhật tuần này (không tính ca đã huỷ).',
    tasks: 'Nhiệm vụ chờ: số nhiệm vụ chưa hoàn thành đang giao cho bạn.',
    late: 'Đi muộn: số lần chấm công vào sau giờ bắt đầu ca trong tuần.',
    onTime: 'Đúng giờ: tỷ lệ chấm công đúng giờ trên các ca đã kết thúc trong tuần.',
  },
  weekShifts: {
    title: 'Ca được giao tuần này',
    cancelledOnly: 'Nghỉ (ca đã huỷ)',
    noShift: '— Không có ca',
    error: 'Không tải được lịch tuần này.',
  },
  quickLinks: {
    leave: { label: 'Nghỉ phép', path: '/leave-requests', locked: false },
    payslip: { label: 'Phiếu lương', path: null, locked: true },
    history: { label: 'Lịch sử', path: '/attendance/history', locked: false },
  },
  payslipSheet: {
    label: 'Phiếu lương',
    body: 'Phiếu lương — Tính năng đang được xây dựng — phiếu lương chi tiết sẽ sớm ra mắt. Bạn sẽ nhận được thông báo khi mở.',
  },
  emptyState: {
    text: 'Hôm nay bạn không có ca',
    cta: 'Xem lịch tuần',
  },
  error: {
    banner: '⚠ Không tải được dữ liệu trang chủ.',
    retry: 'Thử lại',
  },
  refreshing: '↻ Đang làm mới...',
} as const;

// ============================================================================
// Helpers
// ============================================================================

// 2026-08-25 (verify SUMMARY mục 2): input có thể là "HH:mm:ss" (schedule,
// giờ tường thuật địa phương — KHÔNG cần đổi múi giờ) HOẶC ISO datetime
// "YYYY-MM-DDTHH:mm:ss[Z|±HH:MM]" (attendance clock_in/out — cột DB
// `DateTime(timezone=True)`, giá trị LÀ UTC).
// 2026-09-14 (BOT-069, GH#886): bản trước chỉ `slice(11, 16)` — cắt thô ký
// tự, không hề đổi múi giờ. Với chuỗi ISO thiếu hậu tố offset (naive nhưng
// NGỮ NGHĨA vẫn UTC — asyncpg có thể trả về dạng này dù cột `timezone=True`),
// hiện đúng y giờ UTC ra màn hình → lệch đúng 7 tiếng so với giờ VN thật
// (02:53 hiện thay vì 09:53 — đúng bằng chứng trong issue). Ép rõ UTC nếu
// chuỗi thiếu offset rồi mới đổi sang giờ VN, KHÔNG suy đoán múi giờ trình duyệt.
const fmtTime = (t?: string | null) => {
  if (!t) return '--:--';
  if (t.includes('T')) {
    const hasOffset = /Z$|[+-]\d{2}:\d{2}$/.test(t);
    const d = new Date(hasOffset ? t : `${t}Z`);
    if (Number.isNaN(d.getTime())) return '--:--';
    return d.toLocaleTimeString('vi-VN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Ho_Chi_Minh',
    });
  }
  const hhmm = t.slice(0, 5);
  return /^\d{2}:\d{2}$/.test(hhmm) ? hhmm : '--:--';
};

const toISODate = (d: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Monday–Sunday range containing today, as YYYY-MM-DD strings.
const getCurrentWeekRange = (): { start: string; end: string; days: string[] } => {
  const now = new Date();
  const dayOfWeek = now.getDay(); // 0=Sun..6=Sat
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() + diffToMonday);
  const days = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    return toISODate(d);
  });
  return { start: days[0], end: days[6], days };
};

const VIET_DAY_SHORT = ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'];
const viDayShort = (isoDate: string): string => {
  const d = new Date(`${isoDate}T00:00:00`);
  return VIET_DAY_SHORT[d.getDay()];
};

// Port của mobile/src/constants/shiftCodes.ts findShiftCodeByTimes — mã ca
// chuẩn (M/A/N) hiển thị trước giờ trong "Ca được giao tuần này".
const SHIFT_CODES: ReadonlyArray<{ code: string; startTime: string; endTime: string }> = [
  { code: 'M1', startTime: '07:00', endTime: '13:00' },
  { code: 'M2', startTime: '07:00', endTime: '14:00' },
  { code: 'M3', startTime: '07:00', endTime: '16:00' },
  { code: 'M4', startTime: '07:30', endTime: '16:30' },
  { code: 'M5', startTime: '06:00', endTime: '18:00' },
  { code: 'M6', startTime: '07:00', endTime: '17:00' },
  { code: 'M7', startTime: '08:00', endTime: '18:00' },
  { code: 'M8', startTime: '08:00', endTime: '16:00' },
  { code: 'M9', startTime: '09:00', endTime: '17:30' },
  { code: 'M10', startTime: '09:00', endTime: '19:00' },
  { code: 'M11', startTime: '09:00', endTime: '21:00' },
  { code: 'M12', startTime: '08:00', endTime: '21:00' },
  { code: 'A1', startTime: '10:00', endTime: '14:00' },
  { code: 'A2', startTime: '10:00', endTime: '18:00' },
  { code: 'A3', startTime: '10:00', endTime: '20:00' },
  { code: 'A4', startTime: '10:30', endTime: '20:30' },
  { code: 'A5', startTime: '10:00', endTime: '22:00' },
  { code: 'A6', startTime: '10:00', endTime: '22:00' },
  { code: 'A7', startTime: '10:00', endTime: '23:00' },
  { code: 'A8', startTime: '12:00', endTime: '18:00' },
  { code: 'A9', startTime: '12:00', endTime: '20:00' },
  { code: 'A10', startTime: '12:00', endTime: '21:00' },
  { code: 'A11', startTime: '12:00', endTime: '22:00' },
  { code: 'N1', startTime: '14:00', endTime: '22:00' },
  { code: 'N2', startTime: '15:00', endTime: '23:00' },
  { code: 'N3', startTime: '16:00', endTime: '22:00' },
  { code: 'N4', startTime: '16:00', endTime: '24:00' },
  { code: 'N5', startTime: '17:00', endTime: '22:00' },
  { code: 'N6', startTime: '17:00', endTime: '23:00' },
  { code: 'N7', startTime: '17:00', endTime: '05:00' },
  { code: 'N8', startTime: '18:00', endTime: '22:00' },
  { code: 'N9', startTime: '18:00', endTime: '24:00' },
  { code: 'N10', startTime: '19:00', endTime: '07:00' },
];

const findShiftCodeByTimes = (startTimeHHmm: string, endTimeHHmm: string): string | null => {
  const start = startTimeHHmm.slice(0, 5);
  const end = endTimeHHmm.slice(0, 5);
  const hit = SHIFT_CODES.find((c) => c.startTime === start && c.endTime === end);
  return hit?.code ?? null;
};

/** HTTP status từ lỗi query (axios) để vẽ chip DASH-{status}; fallback DASH-5xx */
const dashErrorCode = (error: unknown): string => {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;
  return status ? `DASH-${status}` : 'DASH-5xx';
};

type ContentState = 'default' | 'inshift' | 'ended' | 'empty' | 'fresh';

// ============================================================================
// Component — SC-019-EMP-HOME, CSS Modules, zero inline styles
// ============================================================================

export const EmployeeDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  // DD-0026: WebSocket connection drives polling fallback in the hook.
  const { isConnected, isFallbackMode } = useWebSocket();
  const { data, isLoading, isError, error, refetchAll } = useEmployeeDashboard({
    isWsConnected: isConnected && !isFallbackMode,
  });

  // web-sync checklist A.6 (2026-08-15) — "Ca được giao tuần này" widget,
  // nâng cấp G6 (2026-08-25): render mức NGÀY như mobile WeekShiftList.
  const weekRange = useMemo(() => getCurrentWeekRange(), []);
  const { schedules: weekShifts, loading: weekShiftsLoading, error: weekShiftsError } =
    useSchedule(weekRange.start, weekRange.end);

  const userName = user?.full_name || 'bạn';

  // ISSUE-013: Notification bell — BR-LEAVE-001 §4, BR-DASH-002
  const { unreadCount, hasHighPriorityUnread } = useNotifications();
  const [showNotifications, setShowNotifications] = useState(false);
  const notifRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (notifRef.current && !notifRef.current.contains(e.target as Node)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Pull-to-refresh (wireframe: cả 2 platform hỗ trợ kéo-để-làm-mới)
  const touchStartY = useRef<number | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const handlePullRefresh = useCallback(() => {
    setIsRefreshing(true);
    refetchAll();
    setTimeout(() => setIsRefreshing(false), 1000);
  }, [refetchAll]);

  // Sheets: giải thích số liệu tuần + Phiếu lương locked
  const [showStatSheet, setShowStatSheet] = useState(false);
  const [showPayslipSheet, setShowPayslipSheet] = useState(false);

  // Điều hướng HUB → màn Chấm công (G2 — KHÔNG chấm công tại chỗ)
  const goToAttendance = useCallback(() => navigate('/attendance'), [navigate]);

  // Issue #666 / BOT-003: shortcut Đăng xuất ở header — gọi ĐÚNG logout thật
  // từ auth store (không mutate current_user, xem Debugging Pattern #14),
  // cùng cách ProfilePage.tsx:62-65 làm. Bổ sung, KHÔNG thay thế nút gốc.
  const handleLogout = useCallback(() => {
    logout();
    navigate('/login');
  }, [logout, navigate]);

  // ── G6: group week schedules by day (Mon–Sun), chuẩn WeekShiftList ──
  const weekDays = useMemo(() => {
    const byDate = new Map<string, Schedule[]>();
    [...weekShifts]
      .sort(
        (a, b) =>
          a.date.localeCompare(b.date) || a.start_time.localeCompare(b.start_time),
      )
      .forEach((s) => {
        const list = byDate.get(s.date) ?? [];
        list.push(s);
        byDate.set(s.date, list);
      });
    return weekRange.days.map((date) => ({
      date,
      schedules: byDate.get(date) ?? [],
    }));
  }, [weekShifts, weekRange.days]);

  // Số ca còn hiệu lực trong tuần (ô "Ca làm" — cửa sổ TUẦN, quyết định Q2)
  const activeWeekShiftCount = useMemo(
    () => weekShifts.filter((s) => s.status !== 'cancelled').length,
    [weekShifts],
  );

  // G7: số ca hiệu lực HÔM NAY — guard split-shift 2 ca/ngày (SPEC-0207)
  const todayISO = toISODate(new Date());
  const todayActiveShiftCount = weekShifts.filter(
    (s) => s.date === todayISO && s.status !== 'cancelled',
  ).length;
  const twoShiftLimitReached = todayActiveShiftCount >= 2;

  // ── LOADING (G4): skeleton header 1 dòng chào + 1 dòng phụ + skeleton cards,
  //    bottom-nav vẫn hiện bình thường. ──
  if (isLoading) {
    return (
      <div className={styles.dashboard}>
        <header className={styles.header}>
          <div className={styles.skeletonLine} data-testid="loading-skeleton" />
          <div className={styles.skeletonLineShort} />
        </header>
        <main className={styles.main}>
          <div className={styles.skeletonCard} />
          <div className={styles.skeletonCard} />
          <div className={styles.skeletonCard} />
        </main>
        <EmployeeBottomNav />
      </div>
    );
  }

  // ── ERROR (G4): header greeting tĩnh + banner + chip mã lỗi + Thử lại ──
  if (isError) {
    return (
      <div className={styles.dashboard}>
        <header className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.greeting}>
              <div className={styles.greetingText}>{VI.greetingShort(userName)}</div>
              {user?.position && <div className={styles.positionInfo}>{user.position}</div>}
            </div>
          </div>
        </header>
        <main className={styles.main}>
          <div className={styles.errorBanner} role="alert" data-testid="error-banner">
            <p className={styles.errorBannerText}>{VI.error.banner}</p>
            <span className={styles.errorChip} data-testid="error-chip">
              {dashErrorCode(error)}
            </span>
          </div>
          {/* 2026-09-04 (structural parity): mobile renders retry as a
              separate full-width HomeButton sibling AFTER the Banner
              (HomeScreen.tsx:395-407), not nested inside it — moved out of
              .errorBanner accordingly. */}
          <button onClick={() => refetchAll()} className={styles.retryButton}>
            {VI.error.retry}
          </button>
        </main>
        <EmployeeBottomNav />
      </div>
    );
  }

  // ── Content state machine (G3/G7) ──
  const contentState: ContentState = data.isFresh
    ? 'fresh'
    : !data.todayShift
      ? 'empty'
      : data.attendanceState === 'working'
        ? 'inshift'
        : data.attendanceState === 'shift_ended'
          ? 'ended'
          : 'default';

  // G5: "Xin chào" CHỈ state DEFAULT; biến thể khác dùng "Chào"
  const greeting =
    contentState === 'default' ? VI.greetingDefault(userName) : VI.greetingShort(userName);

  // Header subtitle: {position} · {start}–{end} | {position} · Chưa được phân ca | {position}
  const subtitleParts: string[] = [];
  if (user?.position) subtitleParts.push(user.position);
  if (data.todayShift)
    subtitleParts.push(`${fmtTime(data.todayShift.start_time)}–${fmtTime(data.todayShift.end_time)}`);
  // #704 (BOT-015): "Chưa được phân ca" chỉ đúng khi THẬT SỰ chưa có ca nào;
  // nếu Manager đang soạn (hasDraftSchedule), hiện thông điệp khác — không
  // gây hiểu nhầm là chưa được phân công.
  if (contentState === 'fresh') {
    subtitleParts.push(data.hasDraftSchedule ? VI.notPublishedYet : VI.notScheduled);
  }

  const statsCards = [
    { key: 'shifts', value: String(activeWeekShiftCount), label: VI.stats.shifts, clickable: false },
    { key: 'tasks', value: String(data.monthlyStats.pendingTaskCount), label: VI.stats.tasks, clickable: true },
    { key: 'late', value: String(data.monthlyStats.lateCount), label: VI.stats.late, clickable: false },
    { key: 'onTime', value: `${data.monthlyStats.onTimeRate}%`, label: VI.stats.onTime, clickable: false },
  ] as const;

  const quickLinks =
    contentState === 'fresh'
      ? { leave: VI.quickLinks.leave, history: VI.quickLinks.history }
      : VI.quickLinks;

  const handleQuickLink = (path: string | null, locked: boolean) => {
    if (locked && path === null) {
      setShowPayslipSheet(true); // sheet "Sắp có" — không điều hướng
      return;
    }
    if (path) navigate(path);
  };

  const showMainCards = contentState === 'default' || contentState === 'ended';

  return (
    <div
      className={styles.dashboard}
      onTouchStart={(e) => {
        touchStartY.current = e.touches[0].clientY;
      }}
      onTouchEnd={(e) => {
        const startY = touchStartY.current;
        if (typeof startY === 'number' && window.scrollY <= 0 && e.changedTouches[0].clientY - startY > 60) {
          handlePullRefresh();
        }
      }}
    >
      {/* ── Header: greeting + chuông thông báo ── */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.greeting}>
            <div className={styles.greetingText}>{greeting}</div>
            {subtitleParts.length > 0 && (
              <div className={styles.positionInfo}>{subtitleParts.join(' · ')}</div>
            )}
          </div>

          {/* Chuông thông báo — mở danh sách THẬT (NotificationDropdown) */}
          <div ref={notifRef} className={styles.notifWrap}>
            <button
              onClick={() => setShowNotifications(!showNotifications)}
              aria-label={`Thông báo${unreadCount > 0 ? ` (${unreadCount} chưa đọc)` : ''}`}
              className={styles.notifButton}
            >
              🔔
              {unreadCount > 0 && (
                <span
                  className={`${styles.notifBadge} ${hasHighPriorityUnread ? styles.notifBadgeHigh : styles.notifBadgeNormal}`}
                >
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </button>
            {showNotifications && (
              <div className={styles.notifBackdrop} onClick={() => setShowNotifications(false)} />
            )}
            {showNotifications && (
              <div className={styles.notifDropdown}>
                <NotificationDropdown onClose={() => setShowNotifications(false)} />
              </div>
            )}
          </div>

          {/* Issue #666 / BOT-003: shortcut Đăng xuất — icon nhỏ, không phô
              trương, không thay thế nút gốc trong tab "Tôi" (ProfilePage). */}
          <button
            onClick={handleLogout}
            aria-label={VI.logout}
            title={VI.logout}
            className={styles.logoutButton}
            data-testid="header-logout-button"
          >
            <LogOut size={20} aria-hidden="true" />
          </button>
        </div>

        {isRefreshing && <div className={styles.refreshIndicator}>{VI.refreshing}</div>}
      </header>

      {/* ── EMPTY (G3): thay TOÀN BỘ main bằng 1 empty-state card.
           KHÔNG có CTA chấm công (Q6 — BR-ATTN-011 chưa ratify). ── */}
      {contentState === 'empty' ? (
        <main className={styles.main}>
          <div className={styles.emptyStateCard} data-testid="empty-state">
            <div className={styles.emptyIcon}>📭</div>
            <p className={styles.emptyText}>{VI.emptyState.text}</p>
            <button className={styles.ghostButton} onClick={() => navigate('/schedule')}>
              {VI.emptyState.cta}
            </button>
          </div>
        </main>
      ) : (
        <main className={styles.main}>
          {/* ── Card [3] "Chấm công" — nội dung rẽ nhánh theo state ── */}
          <div className={styles.attendanceCard} data-testid="attendance-card">
            {contentState === 'fresh' ? (
              /* FRESH (G3): giải thích, KHÔNG nút.
                 #704 (BOT-015): text rẽ nhánh theo hasDraftSchedule — NV có
                 ca DRAFT (Manager đang soạn, chưa xuất bản) thấy thông điệp
                 khác với NV thật sự chưa từng được phân ca.
                 2026-09-04 (structural parity): mobile's CardHeader renders
                 title="Chấm công" in FRESH too (HomeScreen.tsx:451-456) — web
                 was skipping straight to the paragraph, dropping the title. */
              <>
                <h2 className={styles.attendanceCardTitle}>{VI.attendance.title}</h2>
                <p
                  className={styles.freshNote}
                  data-testid="fresh-note"
                  data-draft-schedule={data.hasDraftSchedule ? 'true' : 'false'}
                >
                  {data.hasDraftSchedule ? VI.attendance.freshNoteDraft : VI.attendance.freshNote}
                </p>
              </>
            ) : contentState === 'inshift' ? (
              /* IN-SHIFT: "✓ Đã vào ca lúc HH:mm" + pill Đang làm + nút đỏ ra
                 + link checklist — cả 2 cùng ĐIỀU HƯỚNG sang màn Chấm công.
                 KHÔNG emoji glyph; màu đỏ từ variant danger. */
              <>
                <div className={styles.workingStatus} data-testid="in-shift-line">
                  ✓ {VI.attendance.inShiftLine(fmtTime(data.clockInTime))}
                </div>
                <div className={styles.cardTitleRow}>
                  <h2 className={styles.attendanceCardTitle}>{VI.attendance.title}</h2>
                  <span className={styles.workingPill} data-testid="working-pill">
                    {VI.attendance.workingPill}
                  </span>
                </div>
                <button
                  onClick={goToAttendance}
                  className={styles.buttonClockOut}
                  aria-label={VI.attendance.clockOut}
                >
                  {VI.attendance.clockOut}
                </button>
                <button
                  onClick={goToAttendance}
                  className={styles.checklistLink}
                  data-testid="checklist-link"
                >
                  {VI.attendance.checklistLink} <ChevronRight aria-hidden="true" />
                </button>
              </>
            ) : contentState === 'ended' ? (
              /* DEFAULT-ENDED (G7 — FRAME 1c + SPEC-0207 + FR-SS-001 A/C):
                 pill "Đã hết ca" + Vào/Ra + CTA ca 2 enable khi <2 ca/ngày.
                 2026-09-04 (structural parity): mobile's CardHeader shows
                 title="Chấm công" + Pill("Đã hết ca") together as one row in
                 ENDED too (HomeScreen.tsx:488-496, action=Pill) — web was
                 rendering only the bare pill with no title. Reuses
                 .cardTitleRow, the same title+Pill row IN-SHIFT already
                 uses below. */
              <>
                <div className={styles.cardTitleRow}>
                  <h2 className={styles.attendanceCardTitle}>{VI.attendance.title}</h2>
                  <span className={styles.endedPill} data-testid="ended-pill">
                    {VI.attendance.endedPill}
                  </span>
                </div>
                <div className={styles.endedMeta} data-testid="ended-meta">
                  {VI.attendance.endedMeta(fmtTime(data.clockInTime), fmtTime(data.clockOutTime))}
                </div>
                {twoShiftLimitReached ? (
                  <>
                    <button className={`${styles.buttonClockIn} ${styles.buttonDisabled}`} disabled aria-disabled="true">
                      {VI.attendance.secondShiftCta}
                    </button>
                    <p className={styles.limitReason} data-testid="limit-reason">
                      {VI.attendance.limitReason}
                    </p>
                  </>
                ) : (
                  <button onClick={goToAttendance} className={styles.buttonClockIn}>
                    {VI.attendance.secondShiftCta}
                  </button>
                )}
              </>
            ) : (
              /* DEFAULT: CTA chấm công vào → ĐIỀU HƯỚNG màn Chấm công (G2) */
              <>
                <h2 className={styles.attendanceCardTitle}>{VI.attendance.title}</h2>
                <p className={styles.todayHasShift}>
                  {data.todayShift &&
                    VI.attendance.todayHasShift(
                      fmtTime(data.todayShift.start_time),
                      fmtTime(data.todayShift.end_time),
                    )}
                </p>
                <button
                  onClick={goToAttendance}
                  className={styles.buttonClockIn}
                  aria-label={VI.attendance.clockIn}
                  data-testid="clock-in-cta"
                >
                  ● {VI.attendance.clockIn}
                </button>
                <p className={styles.clockInNote}>{VI.attendance.clockInNote}</p>
              </>
            )}
          </div>

          {/* Các card còn lại chỉ ở DEFAULT / DEFAULT-ENDED (IN-SHIFT ẨN HẲN
              theo emp-01-inshift — quyết định G1; FRESH có layout riêng) */}
          {(showMainCards || contentState === 'fresh') && (
            <>
              {/* Card [5] "Tuần này" — cửa sổ TUẦN (quyết định Q2) */}
              {showMainCards && (
                <div className={styles.statsSection}>
                  <div className={styles.statsTitleRow}>
                    <h2 className={styles.sectionTitle}>{VI.stats.title}</h2>
                    <button
                      onClick={() => setShowStatSheet(true)}
                      className={styles.statInfoButton}
                      aria-label={VI.stats.infoA11y}
                      data-testid="stats-info-button"
                    >
                      ⓘ
                    </button>
                  </div>
                  <div className={styles.statsGrid4} role="group" aria-label={VI.stats.title}>
                    {/* 2026-08-25 (verify SUMMARY mục 3d): cả 4 ô đồng nhất
                        chiều render SỐ trên / NHÃN dưới (wireframe ASCII) —
                        trước đây ô clickable dùng CSS order đảo ngược trong
                        khi 3 ô div thì không, gây bất nhất trong cùng grid. */}
                    {statsCards.map((card) =>
                      card.clickable ? (
                        <button
                          key={card.key}
                          type="button"
                          className={styles.statCardClickable}
                          onClick={() => navigate('/tasks')}
                          data-testid={`stat-${card.key}`}
                        >
                          <span className={styles.statValue}>{card.value}</span>
                          <span className={styles.statLabel}>{card.label}</span>
                        </button>
                      ) : (
                        <div key={card.key} className={styles.statCard} data-testid={`stat-${card.key}`}>
                          <div className={styles.statValue}>{card.value}</div>
                          <div className={styles.statLabel}>{card.label}</div>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              )}

              {/* Card [6] "Ca được giao tuần này" — mức NGÀY chuẩn mobile (G6) */}
              {showMainCards && (
                <div className={styles.shiftSection} data-testid="week-shifts-widget">
                  <h2 className={styles.sectionTitle}>{VI.weekShifts.title}</h2>
                  {weekShiftsLoading ? (
                    <div className={styles.weekShiftEmpty}>...</div>
                  ) : weekShiftsError ? (
                    <div className={styles.weekShiftEmpty}>{VI.weekShifts.error}</div>
                  ) : (
                    <ul className={styles.weekDayList}>
                      {weekDays.map((day) => {
                        const active = day.schedules.filter((s) => s.status !== 'cancelled');
                        const cancelledOnly = active.length === 0 && day.schedules.length > 0;
                        return (
                          <li key={day.date} className={styles.weekDayRow}>
                            <span className={styles.weekDayLabel}>{viDayShort(day.date)}</span>
                            <div className={styles.weekDayDetail}>
                              {active.length > 0 ? (
                                active.map((shift) => {
                                  const code = findShiftCodeByTimes(shift.start_time, shift.end_time);
                                  const branchName = (shift as Schedule & { branch_name?: string }).branch_name;
                                  return (
                                    <div key={shift.id} className={styles.weekShiftLine}>
                                      <span className={styles.weekShiftTime}>
                                        {code ? `${code} · ` : ''}
                                        {fmtTime(shift.start_time)}–{fmtTime(shift.end_time)}
                                      </span>
                                      {branchName && (
                                        <span className={styles.weekBranch}>📍 {branchName}</span>
                                      )}
                                    </div>
                                  );
                                })
                              ) : cancelledOnly ? (
                                <span className={styles.weekMuted}>{VI.weekShifts.cancelledOnly}</span>
                              ) : (
                                <span className={styles.weekMuted}>{VI.weekShifts.noShift}</span>
                              )}
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </div>
              )}

              {/* Card [7] "Tính năng khác" — DEFAULT: 3 ô; FRESH: 2 ô (bỏ
                  Phiếu lương); locked mở sheet "Sắp có" */}
              <div className={styles.quickActionRow} role="group" aria-label="Liên kết nhanh">
                {(Object.entries(quickLinks) as Array<[string, typeof VI.quickLinks[keyof typeof VI.quickLinks]]>).map(
                  ([key, link]) => (
                    <button
                      key={key}
                      type="button"
                      /* 2026-08-25 (verify SUMMARY mục 4): KHÔNG disabled —
                         wireframe yêu cầu locked tile VẪN BẤM ĐƯỢC để mở
                         sheet giải thích; chỉ cấm điều hướng (path=null →
                         handleQuickLink mở sheet "Sắp có"). */
                      onClick={() => handleQuickLink(link.path, link.locked)}
                      className={`${styles.quickLinkTile} ${link.locked ? styles.quickLinkTileLocked : ''}`}
                      data-testid={`quick-link-${key}`}
                    >
                      <span>{link.label}</span>
                      {link.locked ? (
                        <span className={styles.quickLinkTileBadge}>Sắp có</span>
                      ) : (
                        <ChevronRight className={styles.quickLinkTileChevron} aria-hidden="true" />
                      )}
                    </button>
                  ),
                )}
              </div>
            </>
          )}
        </main>
      )}

      {/* Sheet: giải thích số liệu tuần */}
      {showStatSheet && (
        <div className={styles.modalOverlay} onClick={() => setShowStatSheet(false)}>
          <div
            className={styles.sheetContent}
            role="dialog"
            aria-label={VI.statSheet.title}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className={styles.sheetTitle}>{VI.statSheet.title}</h3>
            <p className={styles.sheetBody}>{VI.statSheet.shifts}</p>
            <p className={styles.sheetBody}>{VI.statSheet.tasks}</p>
            <p className={styles.sheetBody}>{VI.statSheet.late}</p>
            <p className={styles.sheetBody}>{VI.statSheet.onTime}</p>
            <button className={styles.ghostButton} onClick={() => setShowStatSheet(false)}>
              Đóng
            </button>
          </div>
        </div>
      )}

      {/* Sheet: Phiếu lương locked "Sắp có" */}
      {showPayslipSheet && (
        <div className={styles.modalOverlay} onClick={() => setShowPayslipSheet(false)}>
          <div
            className={styles.sheetContent}
            role="dialog"
            aria-label={VI.payslipSheet.label}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className={styles.sheetTitle}>{VI.payslipSheet.label}</h3>
            <p className={styles.sheetBody}>{VI.payslipSheet.body}</p>
            <button className={styles.ghostButton} onClick={() => setShowPayslipSheet(false)}>
              Đóng
            </button>
          </div>
        </div>
      )}

      {/* Bottom-tab chrome dùng chung (Q1 — giữ nguyên số tab hiện có) */}
      <EmployeeBottomNav />
    </div>
  );
};

export default EmployeeDashboard;
